export const parseTL = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = parseFloat(String(v).replace(/\./g, "").replace(",", "."));
  return isNaN(n) ? null : n;
};

export const fmtAmountInput = (n) => {
  if (n === null || n === undefined || n === "") return "";
  const [i, d] = String(n).split(".");
  const g = i.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return d ? `${g},${d}` : g;
};
const fmtNumberInput = fmtAmountInput;

const formatTLInput = (raw) => {
  let s = String(raw).replace(/[^\d,]/g, "");
  const idx = s.indexOf(",");
  let intPart = idx === -1 ? s : s.slice(0, idx);
  const decPart = idx === -1 ? null : s.slice(idx + 1).replace(/,/g, "").slice(0, 2);
  intPart = intPart.replace(/^0+(?=\d)/, "");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return decPart === null ? grouped : `${grouped},${decPart}`;
};

export default function AmountInput({ value, onChange, testid, placeholder, disabled, className, title, required, onKeyDown, onBlur, onFocus }) {
  const display = typeof value === "number" ? fmtNumberInput(value) : (value ?? "");
  return (
    <input type="text" inputMode="decimal" autoComplete="off"
      data-testid={testid} placeholder={placeholder} disabled={disabled} title={title} required={required} onKeyDown={onKeyDown} onBlur={onBlur} onFocus={onFocus}
      value={display} onChange={(e) => onChange(formatTLInput(e.target.value))}
      className={className} />
  );
}
